import MuxPlayer from '@mux/mux-player-react/lazy';
import React from 'react';
import type { EmbedVideo as Props } from './embed-video.types';

const EmbedVideo: React.FunctionComponent<Props> = ({ autoplay, mediaId }) => {
  if (!mediaId) {
    return null;
  }
  return (
    <div className="embed-video">
      <MuxPlayer
        loading="viewport"
        playbackId={mediaId}
        autoPlay={autoplay}
        className="embed-video__player"
      />
    </div>
  );
};

export default EmbedVideo;
